<template>
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong class="card-title mb-3">{{''+ sector_data_types[sType].value}}</strong>
        </div>
        <div class="col-md-1">
          <download :tableId="'sector-sales'" :fileName="sector_data_types[sType].filename"></download>
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body">
      <div class="row mb5">
        <div class="col-md-3">
          <div class="form-group">
            <select class="form-control" name="sector" v-model="sType" @change="fetchData">
              <option value>Select Field</option>
              <option
                v-for="(sec, index) in sector_data_types"
                :value="index"
                v-bind:key="sec.id+index"
              >{{sec.value}}</option>
            </select>
          </div>
        </div>
        <div class="col-md-6 br"></div>
        <div class="col-md-3">
          <div class="form-group">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
              @keyup="filteredList($event)"
            >
          </div>
        </div>
      </div>
      <div class="table-responsive app" v-dragscroll="true">
        <table id="sector-sales" class="table table-sm fonts11 table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
              <th v-for="year in last10years" :key="'yearth'+year">{{year}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in rawData" v-bind:key="'row'+index">
              <td>
                <!-- <span v-if="!isFromDashBoard">{{(index+1)+(perPage*($refs.page.current_page-1))}}</span> -->
                <span>{{(index+1)}}</span>
              </td>
              <td v-for="field in tableFields" v-bind:key="field.name+index">
                <span v-if="field.name==='time'">{{getDateTime(row[field.name])}}</span>
                <span v-else>{{row[field.name]}}</span>
              </td>
              <td
                v-for="(year,ind) in last10years"
                v-bind:key="'yeartd'+ind"
              >{{getFixed(row[year])}}</td>
            </tr>
          </tbody>
          <tfoot v-if="rawData.length==0">
            <tr>
              <td :colspan="(tableFields.length+1+last10years.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";

export default {
  mixins: [commonMixins],
  name: "SectorSales",
  created() {
    console.log("Config ", process.env.API_URL);
    if (this.isFromDashBoard) {
      this.url = this.apiUrl + this.page;
    } else {
      this.url = this.apiUrl;
    }
    this.fetchData(0);
    this.getLastTenYears();
  },
  data() {
    return {
      apiUrl: "getAllSectorSales",
      apiMode: true,
      company: {},
      tableFields: [
        {
          name: "sectorcode",
          title: "Code"
        },
        {
          name: "sectorname",
          title: "Sector"
        }
      ],
      searchParams: {},
      searchText: "",
      searchData: [],
      rawData: [],
      sector_data_types: [
        { id: "sector_ebitDA", value: this.getCustomLabel("sector_ebitDA"),
          filename: "sector-ebitDA" },
        { id: "sector_sales", value: this.getCustomLabel("sector_sales"),
          filename: "sector-sales" },
        {
          id: "sector_net_profit",
          value: this.getCustomLabel("sector_net_profit"),
          filename: "sector-net-profit"
        },
        {
          id: "sector_total_dividend_paid",
          value: this.getCustomLabel("sector_total_dividend_paid"),
          filename: "sector-tot-div-paid"
        },
        {
          id: "sector_market_cap_per_sector_total_dividend_paid",
          value: this.getCustomLabel(
            "sector_market_cap_per_sector_total_dividend_paid"
          ),
          filename: "sector-mc-per-tot-div-paid"
        },
        {
          id: "sector_market_cap_per_sector_sales",
          value: this.getCustomLabel("sector_market_cap_per_sector_sales"),
          filename: "sector-mc-per-sales"
        },
        {
          id: "sector_market_cap_per_sector_net_profit",
          value: this.getCustomLabel("sector_market_cap_per_sector_net_profit"),
          filename: "sector-mc-per-net-profit"
        }
      ],
      sType: 0
    };
  },
  methods: {
    search() {
      console.log(this.searchParams);
      if (
        this.searchParams.companyname.length > 2 ||
        this.searchParams.sectorname != ""
      ) {
        if (this.searchParams.sectorname != "") {
          localStorage.setItem("secC", this.searchParams.sectorname);
        }
        this.fetchData(this.searchParams);
      }
      if (
        this.searchParams.companyname.length == 0 &&
        this.searchParams.sectorname == ""
      ) {
        console.log("Reset");
        this.reset();
      } else {
        console.log("Not Reset");
      }
      // this.$refs.search.searchIn(this.searchParams);
    },
    fetchData() {
      let myself = this;
      let params = { sector_param: myself.sector_data_types[myself.sType].id };
      http.post(myself.apiUrl, params, function(error, response) {
        console.log(response);
        myself.rawData = response;
        myself.searchData = response;
        console.log("PAges", myself.pages);
      });
    },
    filteredList(e) {
      if (this.searchText === null || this.searchText === "") {
        this.rawData = this.searchData;
        return this.rawData;
      } else if (this.searchText.length <= 2) {
        this.rawData = this.searchData;
        return this.rawData;
      }
      if (this.searchText.length > 2 || e.keyCode === 13) {
        this.rawData = this.rawData.filter(rd => {
          console.log(
            rd.sectorcode.toLowerCase().includes(this.searchText.toLowerCase())
          );
          return (
            rd.sectorcode.toLowerCase().includes(this.searchText.toLowerCase()) ||
            (rd.sectorname
              ? rd.sectorname
                  .toLowerCase()
                  .includes(this.searchText.toLowerCase())
              : false)
          );
        });
      }
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/industry/sector-sales.vue